<template>
  <div>
    <div
      class="panorama-container" 
    >
      <iframe 
          :src="panoramaSrc()" 
          width="100%"
          height="340px"
          style="border:none;"
      >
      </iframe>
      <div 
        class="room-audio"
        :key="`audio-${selected.orderNumber}`"
      > 
        <audio 
          controls
        >
          <source :src="selected.audio" type="audio/mpeg">
          Your browser does not support the audio element.
        </audio>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'preview',
  components: {
  },
  props: {
    
  },
  data () {
    return {
      panoramas: [
            {
                orderNumber: 1,
                title: 'Berliner Zimmer',
                src: 'https://mp-panoramas.culture-to-go.de/berliner-zimmer/index.html'
            },
            {
                orderNumber: 2,
                title: 'Wohnzimmer',
                src: 'https://mp-panoramas.culture-to-go.de/wohnzimmer/index.html'
            },
            {
                orderNumber: 3,
                title: 'Herrenzimmer',
                src: 'https://mp-panoramas.culture-to-go.de/herrenzimmer/index.html'
            }

        ]
    }
  },
  computed: {
    ...mapGetters({
        videos: 'getVideosData',
        // marked: 'getMarkedVideo',
        selected: 'getSelectedRoom'
    }),
    markedVideoThumb () {
      const thumb = this.marked
        ? this.videos.find(v => v.orderNumber === this.marked).thumb
        : undefined
      return thumb
    }

  },
  methods: {
    ...mapActions({
        
    }),
    callPanorama(nr) {
      // this.$router.push(`/panorama/${nr}`)
      this.$router.push(`/raum/${nr}`)
    },
    panoramaSrc() {
        return this.panoramas.find(p => p.orderNumber.toString() === this.selected.orderNumber)
            ? this.panoramas.find(p => p.orderNumber.toString() === this.selected.orderNumber).src
            : undefined
    },
    toggleAudio() {
      this.firstAudio = !this.firstAudio
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
@import '@/scss/custom.scss';
.panorama-container {
  width: 46%;
  position: absolute;
  top: 0;
  right: 0;
  z-index: 800;
  background-color: rgba(83,73,63,.65);
  @media (max-width: $laptop) {
    position: relative;
    width: calc(100vw - 6rem);
    margin-top: 2rem;
  }
}
.room-preview {
    width: 46%;
    position: absolute;
    top: 0;
    right: 0;
    z-index: 800;
    .preview-thumb {
      display: block;
      width: 100%;
    }
    .preview-title {
      padding: .4rem .8rem; 
      background-color: $red-light;
      color: $sand-light;
      font-size: $font-text-md;
      font-family: 'Titillium Web';
      font-weight: 400;
    }
    .play-button {
      position: absolute;
      top: calc(50% - 3.6rem);
      left: 0;
      width: 100%;
      img {
        display: block;
        width: 6rem;
        margin: 0 auto;
      }
    }
}
.back-to-room {
    font-size: 1.4rem;
    text-align: center;
    margin-top: 1rem;
    color: $red-dark;
    font-family: 'Titillium Web';
    font-weight: 600;

}
// player styling
.room-audio {
  // background-color: rgba(83,73,63,.65);
  padding: 0 0 .4rem 0;
  audio {
    display: block;
    max-height: 2rem;
    max-width: 100%;
    margin: 0 auto;
  }
}
</style>
